import { AbstractControl, ValidationErrors } from "@angular/forms"
import { FormlyFieldConfig } from "@ngx-formly/core"
import { FormValidation } from "../form/form-validation"
import { TableLayoutFormlyFieldGroup } from "../../model/dyn-form/form-visualizer/formly-group.model"
import { FormlyValidationType } from "./formly-validation-type"

export class FormlyValidation {

    public static isEmail(control: AbstractControl, field: FormlyFieldConfig): ValidationErrors | null {
        if (FormlyValidation.isNullOrEmpty(control.value)) {
            return { 'email' : true, 'isTable' : FormlyValidation.isTable(field) }
        }
        return FormValidation.isEmail(control.value) ? null : { 'email' : true, 'isTable' : FormlyValidation.isTable(field) }
    }



    // All methods used inside public validations //

    private static isTable(field: FormlyFieldConfig): boolean {
        return field.parent?.parent?.parent instanceof TableLayoutFormlyFieldGroup
    }

    private static isNullOrEmpty(value: string): boolean {
        return !value || value.trim().length == 0
    }

}

export const FormlyValidations = [
    { name: FormlyValidationType.email, validation: FormlyValidation.isEmail }
]

export const FormlyValidationsEditor = [
    { name: 'Email validació', value: FormlyValidationType.email }
]